import React from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Box, Button, H2, Text, VStack } from '@betterment/samba-react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { CustomerSignupValues } from './Controller';
import { OccupationSelectField } from './EmploymentForm';

import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';

const LegacyStepSchema = Yup.object<{ value: string }>().shape({
  value: Yup.string().required('Occupation cannot be blank'),
});

interface LegacyOccupationProps extends StepProps<CustomerSignupValues> {
  initialRole: string;
  roleOptions: string[];
  handleClose: () => void;
}

const LegacyOccupation: React.FC<LegacyOccupationProps> = ({
  flowState,
  initialRole,
  roleOptions,
  goToPreviousStep,
  goToNextStep,
  handleClose,
}) => {
  const { stepTitle } = flowState.values;

  const handleSubmit = ({ value }: { value: string }) => {
    track('ElementClicked', { name: 'Continue', flow: 'OpenCheckingAccount' });
    goToNextStep({ role: value });
  };

  return (
    <WorkflowLayout
      pageTitle="Sign up - Checking"
      workflowTitle={stepTitle}
      onBack={goToPreviousStep}
      onClose={handleClose}
    >
      <H2 color="text">Tell us about your employment.</H2>
      <Box css={{ marginY: 'space.200' }}>
        <Text as="p" color="text" css={{ marginBottom: 'space.300' }}>
          We&apos;re required by our regulators to collect this information.
        </Text>
      </Box>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={LegacyStepSchema}
        initialValues={{ value: initialRole }}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <Form>
            <VStack css={{ gap: 'space.300', width: '100%' }}>
              <OccupationSelectField name="value" label="Occupation" options={roleOptions} />
            </VStack>
            <Button
              type="submit"
              css={{ mt: 'space.400', width: { base: '100%', md: 'auto' } }}
              disabled={isSubmitting}
            >
              Continue
            </Button>
          </Form>
        )}
      </Formik>
    </WorkflowLayout>
  );
};

export default LegacyOccupation;
